import buyer from "./buyer";
import seller from "./seller";
import validation from "./validation";

export default {
  validation: validation,
  seller: seller,
  buyer: buyer,
};